import * as _4 from 'lodash4';
import { APGenericSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { MyPlannerTermBoxButton } from '../term_box_button/term_box_button';

class TermBoxMenu extends MyPlannerTermBoxButton {
  public deletePopupHidden: boolean = true;
  private showLockUnlockCoursesModal = false;
  public regMenuItemText: string = '';
  public showRegMenu: boolean;
  public headerMenuItemText: string = '';
  public popupMenuId: string;
  public showRemoveTerm: boolean = false;
  private isAdvisor = false;
  private showLockCoursesOption = false;
  private showUnLockCoursesOption = false;
  private isLocking = true;
  private coursesCount = 0;
  private terms: APTerm[] = [];

  constructor(
    public $scope: ng.IScope,
    public $state: ng.ui.IStateService,
    public $modal: any,
    // TODO: Once the refactoring is done, remove this and call command directly
    public appConfigModel: any,
    public ngAPUserModeConfig: APUserModeConfig
  ) {
    super($scope, $state, $modal, appConfigModel, ngAPUserModeConfig);
    this.popupMenuId = _4.uniqueId();
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  openDeleteTermPopup() {
    if (this.showRemoveTerm) {
      this.deletePopupHidden = false;
    }
  }
  closeDeleteTermPopup() {
    this.deletePopupHidden = true;
  }
  lockAllCourses() {
    // Show the lock confirmation popup
    this.showLockUnlockCoursesModal = true;
    this.isLocking = true;
  }

  unLockAllCourses() {
    // Show the lock confirmation popup
    this.showLockUnlockCoursesModal = true;
    this.isLocking = false;
  }
  initialize() {
    this.setMenuItemTexts();
    this.showRemoveTerm = _4.every(this.term._genericSlots, (genericSlot: APGenericSlot) =>
      _4.isEmpty(genericSlot.status)
    );
    // we don't want to show 'Remove term' menu item for student if any locked course present
    if (this.showRemoveTerm && this.ngAPUserModeConfig.isStudent()) {
      this.showRemoveTerm = !(this.term as APTerm)._isLockedByAdvisorCoursePresent;
    }
    this.showRegMenu = this.showRegButton();
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    this.showLockCoursesOption = this.isAdvisor && _4.get(this.term, '_showLockAllCourses', false);
    this.showUnLockCoursesOption = this.isAdvisor && _4.get(this.term, '_showUnLockAllCourses', false);
    this.terms = [this.term];
  }

  setMenuItemTexts() {
    const termStatus = this.term._termStatus.value || this.term._termStatus;
    this.regMenuItemText = termStatus.button_label || 'Pick Times';
    this.headerMenuItemText = _4.template(termStatus.status_title_plain)({
      registration_start_date: moment(this.term.registration_start_dt).format('MMMM DD'),
      term_start_date: moment(this.term.term_start_dt).format('MMMM DD')
    });
  }
}

angular.module('capability-ng-academic-planner').component('termBoxMenu', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/term_box_menu/term_box_menu.html',
  bindings: {
    term: '<',
    isPast: '<?'
  },
  controller: TermBoxMenu
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_box_menu/term_box_menu.ts